export default __webpack_public_path__ + "static/properties/20251021-210737.938/common_de.properties";